import { FAQ_SEARCH } from "../../gql/StaticPagesQueris";
import Pagination from "@/components/Pagination";
import FaqSearch from "../FAQSearchField";

export default {
  name: "faq_search",

  data() {
    return {
      query: "",
      skipFAQSearchQuery: true,
      faqSearch: []
    };
  },

  apollo: {
    faqSearch: {
      query: FAQ_SEARCH,
      fetchPolicy: "no-cache",

      skip() {
        return this.skipFAQSearchQuery;
      },

      variables() {
        return {
          input: this.query,
          page: this.faqSearch.pagination ? this.faqSearch.pagination.page : 1,
          perPage: 20
        };
      },
      result() {
        this.skipFAQSearchQuery = true;
        window.scrollTo({ top: 0 });
      }
    }
  },

  mounted: function() {
    this.query = this.$route.query.query;

    this.skipFAQSearchQuery = false;
  },

  methods: {
    goToPage(current) {
      this.faqSearch.pagination.page = current;
      this.skipFAQSearchQuery = false;
    },

    updateSearchResults(searchString) {
      this.query = searchString;
      this.faqSearch.pagination.page = 1;
      this.skipFAQSearchQuery = false;
      this.$router.replace({
        name: "faq_search",
        query: { query: searchString }
      });
    }
  },

  components: {
    Pagination,
    FaqSearch
  }
};
